import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";

const Terms = () => {
    return (
        <>
            <Seo
                title="Terms & Conditions | FinQ India"
                description="Read the terms and conditions governing use of FinQ India's WhatsApp stock alert service, offered by Konsri Technologies Private Limited."
                path="/terms"
            />
            <Header />
            <Container
                width="min(calc(100% - 40px) , 900px)"
                justifyContent="center"
                margin="20px auto"
                column
                gap={"20px"}
            >
                <Typography
                    tag="h1"
                    fontFamily="Neue Montreal"
                    fontSize={"28px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    Terms & Conditions - FinQ India
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Last updated on <time dateTime="2025-06-19">June 19th, 2025</time>
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    <span style={{ fontWeight: 500, color: "#202020" }}>FinQ India (finq.in)</span> is a stock market alerts platform owned and operated by <span style={{ fontWeight: 500, color: "#202020" }}>KONSRI TECHNOLOGIES PRIVATE LIMITED</span>.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    All content provided by FinQ India is for <span style={{ fontWeight: 500, color: "#202020" }}>informational purposes only</span> and does <span style={{ fontWeight: 500, color: "#202020" }}>not</span> constitute investment advice.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Neither KONSRI TECHNOLOGIES nor FinQ India is responsible for any investment decisions made based on the information provided on this platform.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    We are <span style={{ fontWeight: 500, color: "#202020" }}>not registered investment advisers</span>.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    The terms "we", "us", "our" refer to KONSRI TECHNOLOGIES PRIVATE LIMITED. The terms "you", "your", "user", "visitor" refer to any natural or legal person visiting our website and/or purchasing from us.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    The content of the pages of this website is subject to change without notice. Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    Free Trial & Lifetime Free Plan
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    FinQ India may offer a <span style={{ fontWeight: 500, color: "#202020" }}>free trial period</span> for new users and a <span style={{ fontWeight: 500, color: "#202020" }}>Lifetime Free Plan</span> that allows limited stock tracking at no charge. The duration, features, stock limits, and eligibility criteria for these offers are described on our website and may vary from time to time.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    All terms and conditions relating to the <span style={{ fontWeight: 500, color: "#202020" }}>free trial</span> and the <span style={{ fontWeight: 500, color: "#202020" }}>Lifetime Free Plan</span> — including duration, features, stock limits, eligibility, and availability — are subject to change, modification, suspension, or discontinuation <span style={{ fontWeight: 500, color: "#202020" }}>at our sole discretion and without prior intimation or notice</span> to you.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    The <span style={{ fontWeight: 500, color: "#202020" }}>Lifetime Free Plan</span> is <span style={{ fontWeight: 500, color: "#202020" }}>only applicable in India</span> and is <span style={{ fontWeight: 500, color: "#202020" }}>not available in other countries</span>. Geographic eligibility for trial and free plans is determined solely by us and may be restricted or withdrawn for any region without prior notice. Continued use of any free or trial offer does not create a contractual right to ongoing free access.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    If you have any questions about these Terms & Conditions, please contact us at <a href="mailto:info@konsritech.com">info@konsritech.com</a>.
                </Typography>
            </Container>
        </>
    );
};

export default Terms;
